import { IconButton } from '@nexo/ui';
import { PanelRight } from 'lucide-react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useTeam } from './TeamContext';

/** Page header inside the main panel: title on the left, page actions on the right. */
export function TeamHeader({ children, actions }: { children: ReactNode; actions?: ReactNode }) {
  const { t } = useTranslation();
  const { rightPanel, setRightPanel } = useTeam();
  return (
    <header className="flex h-14 shrink-0 items-center gap-2 border-b border-border px-4 sm:px-5">
      <div className="flex min-w-0 flex-1 items-center gap-2.5">{children}</div>
      {actions}
      {/* The utility rail is hidden on small screens; this opens the side panels there. */}
      <IconButton
        label={t('Paneles')}
        className="md:hidden"
        active={rightPanel !== null}
        onClick={() => setRightPanel(rightPanel ? null : 'members')}
      >
        <PanelRight />
      </IconButton>
    </header>
  );
}
